<template>
  <section>
    <el-form :model="formObj" label-width="120px" :rules="fromRules" ref="formObj">
      <div class="title"><i></i>交底单基本信息</div>
      <el-form-item label="项目" prop="proId">
        <el-select v-model="formObj.proId" placeholder="请选择项目" @change="proChange">
          <el-option v-for="(item,index) in GLOBAL.proList" :key="item.id" :value="item.id"
                     :label="item.proName"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="交底单名称" prop="discloseName">
        <el-input v-model="formObj.discloseName" auto-complete="off" maxlength="20" show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="单位工程名称" prop="discloseProName">
        <el-input v-model="formObj.discloseProName" auto-complete="off" maxlength="50" show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="交底人" prop="discloseUser">
        <el-select v-model="formObj.discloseUser" placeholder="检查员">
          <el-option v-for="(item,index) in disUsers" :key="item.id" :label="item.employeeName"
                     :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="施工部位" prop="discloseConsPosition">
        <el-input v-model="formObj.discloseConsPosition" auto-complete="off" maxlength="50" show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="分部工程/分项" prop="discloseSortPro">
        <el-select v-model="formObj.discloseSortPro" placeholder="请选择分部工程">
          <el-option :label="item.name" :value="item.id" :key="item.id"
                     v-for="(item,index) in sortProjects"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="备注">
        <el-input v-model="formObj.discloseRemark" auto-complete="off" maxlength="50" show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="交底日期" prop="discloseDate">
        <el-date-picker type="date" placeholder="选择日期" v-model="formObj.discloseDate"></el-date-picker>
      </el-form-item>
      <div class="title"><i></i>接受交底人</div>
      <el-form-item label="接受交底人" prop="acceptUser">
        <work-team-list :team-list="teamList" :team-id="formObj.acceptUser"
                        :team-label="discloseAcceptUserN"></work-team-list>
      </el-form-item>
      <div class="title"><i></i>交底内容</div>
      <el-form-item label="通用交底" prop="discloseCommon">
        <el-input type="textarea" v-model="formObj.discloseCommon" placeholder="请输入交底内容"></el-input>
      </el-form-item>
      <el-form-item label="专用交底" prop="discloseSpecial">
        <el-input type="textarea" v-model="formObj.discloseSpecial" placeholder="请输入交底内容"></el-input>
      </el-form-item>
    </el-form>
    <div class="dialog-footer">
      <el-button @click.native="doCancel">取消</el-button>
      <el-button type="primary" @click.native="doSubmit(option)">确定</el-button>
    </div>
  </section>
</template>

<script>
  import {dataList, tagRoles, workers, discloseCreate, discloseUpdate, proSearch} from '../../api/api'
  import WorkTeamList from "../command/WorkTeamList";

  export default {
    name: "DiscloseForm",
    components: {WorkTeamList},
    props: {
      option: 0,
      formData: {},
      type: 0
    },
    data() {
      return {
        formObj: {proId: null, discloseUser: null, acceptUser: []},
        fromRules: {
          proId: [
            {required: true, message: '请选择项目', trigger: 'change'}
          ],
          discloseName: [
            {required: true, message: '请输入交底单名称', trigger: 'blur'}
          ],
          discloseProName: [
            {required: true, message: '请输入单位工程名称', trigger: 'blur'}
          ],
          discloseUser: [
            {required: true, message: '选择交底人', trigger: 'change'}
          ],
          discloseConsPosition: [
            {required: true, message: '请输入施工部位', trigger: 'blur'}
          ],
          discloseSortPro: [
            {required: true, message: '请选择分部工程/分项', trigger: 'change'}
          ],
          discloseDate: [
            {required: true, message: '请选择交底日期', trigger: 'blur'}
          ],
          discloseCommon: [
            {required: true, message: '请输入通用交底', trigger: 'blur'}
          ],

          acceptUser: [
            {type: 'array', required: true, message: '请至少选择一个接受人', trigger: 'change'}
          ]
        },
        fileList: [],
        sortProjects: [],
        disUsers: null,
        projects: [],
        discloseUser: null,
        proId: null,
        teamList: [],
        discloseAcceptUserN: [],
        discloseAcceptUser: [],
        proList: [],
      }
    },
    methods: {
      doSubmit: function (option) {
        this.$refs.formObj.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {type: 'warning'}).then(() => {
              this.formObj.discloseAcceptUser = this.formObj.acceptUser.join(",");
              this.formObj.discloseAcceptUserN = this.discloseAcceptUserN.join(",");
              if (option == 0) {
                this.formObj.discloseType = this.type;
                discloseCreate(this.formObj, this.GLOBAL.header).then(result => {
                  if (result.success) {
                    this.$message({
                      message: "添加成功",
                      type: 'success'
                    });
                    this.$emit('doSubmit');
                  }
                });
              } else if (option == 1) {
                discloseUpdate(this.formObj, this.GLOBAL.header).then(result => {
                  if (result.success) {
                    this.$message({
                      message: "修改成功",
                      type: 'success'
                    });
                    this.$emit('doSubmit');
                  }
                });
              }
            }).catch(() => {
            });
          }
        });
      },
      doCancel: function () {
        this.$emit('doCancel');
      },
      proChange: function () {
        //如果是质量交底获取质量员列表 如果是安全交底 获取安全员列表
        let tagKey = null;
        if (this.type == this.GLOBAL.qualityType) {
          tagKey = this.GLOBAL.roleTag.quality
        } else {
          tagKey = this.GLOBAL.roleTag.safer;
        }

        if (this.formObj.proId != null) {
          workers({
            key: tagKey,
            comId: this.GLOBAL.user.comId,
            proId: this.formObj.proId
          }, this.GLOBAL.header).then(result => {
            if (result.success) {
              this.discloseUser = null;
              this.disUsers = [];
              this.disUsers = result.data;
              if(this.option == 0){
                if (this.GLOBAL.user.id==1) {
                  this.disUsers.push({id: this.GLOBAL.user.id, employeeName: this.GLOBAL.user.employeeName});
                }
                this.formObj.discloseUser = this.GLOBAL.user.id;
              }
              if (this.option == 1 && this.disUsers.length > 0) {
                  if(this.formObj.discloseUser==1 || this.GLOBAL.user.id==1){
                    this.disUsers.push({id: 1, employeeName: '平台管理员'});
                  }
                  this.formObj.discloseUser = parseInt(this.formObj.discloseUser);
              }
            }
          });
          //指定岗位标记下的岗位集合
          tagRoles({
            key: this.GLOBAL.roleTag.workTeam,
            comId: this.GLOBAL.user.comId,
            proId: this.formObj.proId
          }, this.GLOBAL.header).then(result => {
            if (result.success) {
              this.teamList = [];
              this.teamList = result.data;
            }
          });
        }
      }
    },
    mounted() {
      //初始化表单数据
      this.formObj = this.formData;
      if (this.option == 1) {
        this.formObj.acceptUser = this.formObj.discloseAcceptUser.split(',');
        this.discloseAcceptUserN = this.formObj.discloseAcceptUserN.split(',');
      } else {
        this.formObj.acceptUser = [];
      }
      //加载数据=================================================================
      //分部工程/分项列表
      dataList({key: this.GLOBAL.command.sortProject}, this.GLOBAL.header).then(result => {
        if (result.success) {
          this.sortProjects = result.data
        }
      });
      this.proChange();
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/disclose/DiscloseForm.vue